import emotionList from "./emotionList";

export const getEmotionObject = (emotion_id)=>{
    return emotionList.find((emotion)=> emotion.value === emotion_id)
}